export default __webpack_public_path__ + "static/media/personality-small-share.570ff0fe.svg";